// src/components/constants/Header.js

import React from 'react';

export const Header = ({ user_name, initials, toggleSignOut, isSignOutVisible, handleSignOut }) => {
  return (
    <div className="absolute top-2 right-5 flex items-center gap-3 bg-white px-[10px] py-2 shadow-lg rounded-full border border-gray-200">
      <div className="text-gray-700 text-lg font-normal" style={{fontSize:'15px'}}>
        Hi, <span style={{fontSize:'15px'}} className="font-normal text-[#172e6c]">{user_name}</span>
      </div>
      <div style={{fontSize:'14px'}}
        className="bg-[#172e6c] text-white rounded-full w-10 h-10 flex items-center justify-center font-normal text-xl cursor-pointer relative hover:bg-[#172e6c] transition-all"
        onClick={toggleSignOut}
        title="Click to sign out"
      >
        {initials}
      </div>
      {isSignOutVisible && (
        <div className="absolute top-full mt-2 right-0 bg-white border border-gray-300 rounded shadow-lg w-28 text-center">
          <button
            className="px-4 py-2 text-red-500 hover:bg-gray-100 w-full"
            onClick={handleSignOut}
          >
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
};
